<!-- 翻车机报警配置 -->
<template>
  <dev>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange" :beforeOpen="beforeOpen"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
    </avue-crud>
  </dev>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import {getList, add, update, remove, getDetail} from "./api";
import {searchTimeConfig} from "@/basic-common/util/common";

export default {
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: {getList, add, update, remove, getDetail},
      infoCardData: [], // 卡片数据
      option: {
        ...this.$store.state.publicOption,
        searchDateProp: false,
        column: [
          {
            label: "报警类型",
            prop: "alarmType",
            type: 'select',
            overHidden: true,
            search: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=wagon_alarm_type",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择报警类型', trigger: 'change'}
            ],
          },
          {
            label: "报警级别",
            prop: "alarmLevel",
            type: 'select',
            overHidden: true,
            search: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=wagon_alarm_level",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择报警级别', trigger: 'change'}
            ],
          },
          {
            label: "环节类型",
            prop: "phaseType",
            type: 'select',
            overHidden: true,
            search: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=phase_type",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择环节类型', trigger: 'change'}
            ],
          },
          {
            label: '时间阈值(秒)',
            prop: 'thresholdSeconds',
            type: 'number',
            search: false,
            rules: [
              {required: true, message: '请输入时间阈值(秒)', trigger: 'blur'},
            ],
            precision: 0,
            disabled: false,
            value: 0 // 设置默认值
          },
          {
            label: "是否启用",
            prop: "isActive",
            type: 'select',
            overHidden: true,
            search: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=is_active",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择是否启用', trigger: 'change'}
            ],
            value: 1
          },
          {
            label: '条件表达式',
            prop: 'conditionExpression',
            type: "textarea",
            span: 24,
            minRows: 3,
            hide: false,
            search: false, // 不参与查询
          },
          {
            label: '描述',
            prop: 'description',
            type: "textarea",
            span: 24,
            minRows: 3,
            hide: true,
            search: false, // 不参与查询
          },
          {
            label: '备注',
            prop: 'remark',
            type: "textarea",
            span: 24,
            minRows: 3,
            hide: true,
            search: false, // 不参与查询
            rules: [
              {max: 500, message: '备注不能超过500个字符', trigger: 'blur'}
            ]
          },
          {
            label: "状态",
            prop: "status",
            type: 'select',
            overHidden: true,
            search: false,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=status_flag",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择状态', trigger: 'change'}
            ],
            value: 1
          },
          {
            label: '顺序逻辑校验规则(JSON)',
            prop: 'sequenceLogic',
            type: "textarea",
            span: 24,
            minRows: 3,
            hide: true,
            search: false, // 不参与查询
          },
          {
            label: '方案指导',
            prop: 'solutionGuide',
            type: "textarea",
            span: 24,
            minRows: 3,
            hide: true,
            search: false, // 不参与查询
          },
          {
            label: '知识库引用',
            prop: 'knowledgeBaseRef',
            type: "textarea",
            span: 24,
            minRows: 3,
            hide: true,
            search: false, // 不参与查询
          },
          {
            ...searchTimeConfig,
            searchValue: [],
            paramsKey: ["startTime", "endTime"],
            search: false,
          },
        ]
      },
    }
  }
}
</script>
<style scoped lang="scss">
</style>
